import { render, staticRenderFns } from "./Halloween.vue?vue&type=template&id=74ccaf17&scoped=true&"
import script from "./Halloween.vue?vue&type=script&lang=js&"
export * from "./Halloween.vue?vue&type=script&lang=js&"
import style0 from "./Halloween.vue?vue&type=style&index=0&id=74ccaf17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ccaf17",
  null
  
)

export default component.exports